<template>
  <q-dialog
    v-model="dialog"
    style="width: 600px"
  >
    <q-card
      style="max-width: 600px; width: 100%"
      class="pragma-black text-white"
    >
      <q-card-section class="q-pa-none">
        <q-toolbar class="bg-pragma text-white shadow-2 rounded-borders">
          <q-btn flat label="Vista previa" />
          <q-space />
          <a :href="url" target="_blank" style="color: inherit; text-decoration: none;">
            <q-btn
              icon="download"
              flat
            ></q-btn>
          </a>
          <q-btn
            icon="clear"
            @click="closeDialog()"
            flat
          ></q-btn>
        </q-toolbar>
      </q-card-section>

      <q-card-section class="text-center">
        <div v-if="documentType == 0">
          <q-spinner-bars
            color="blue-grey"
            size="4em"
          />
        </div>
        <iframe :src="url" style="width: 100%; height: 600px" v-if="documentType == 1"></iframe>
        <img :src="url" alt="" class="full-width" v-if="documentType == 2">
        <div v-if="documentType == 3">
          <p>No se puede mostrar este tipo de documento, pero puede descargarlo en su dispositivo</p>
          <p>
            <a :href="url" class="text-white">Descargar</a>
          </p>
        </div>
      </q-card-section>

    </q-card>
  </q-dialog>
</template>

<script>
import { inject, onMounted, ref } from 'vue'

export default {
  setup () {
    const dialog = ref(false)
    const documentType = ref(0)
    const url = ref('')

    const bus = inject('bus')

    const getDocumentType = (name) => {
      let tempArray = name.split('.')
      if (tempArray.length > 0) {
        switch (tempArray[tempArray.length - 1]) {
          case 'pdf':
            documentType.value = 3
            break
          case 'jpg':
          case 'jpeg':
          case 'png':
            documentType.value = 2
            break
          default:
            documentType.value = 3
        }
      }
    }

    const closeDialog = () => {
      dialog.value = false
      documentType.value = 0
      url.value = ''
    }
    onMounted(() => {
      bus.on('openDialogViewFile', (item) => {
        getDocumentType(item)
        url.value = item
        dialog.value = true
      })
    })
    return {
      dialog,
      documentType,
      url,
      closeDialog
    }
  }
}
</script>

<style>

</style>